import React, { Component, ChangeEvent } from 'react';
import * as Actions from '../../../store/actions/userHome';
import { UserType } from '../../../models/pages/login.d';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAppState, IAction } from '../../../models/action/core';
import { ISearchBarProps } from '../../../models/components/search-bar';
import { FilterCourses } from '../../../pages/course/filter';
import { ICourseList } from '../../../models/pages/coursePage';

const T = Translator.create();
const _logger = Log.create('CourseHeader');
class CourseHeader extends React.Component<ICourseList,any> {
    public state = {
        searchBarShow: false,
        searchText: '',
        lastSearchedText: '',
        lessonStatus : 1
    };

    public onSearchClick = () => {
        this.setState(Object.assign({}, {...this.state}, {searchBarShow: true}));
    }


    public onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchText: event.target.value });
    }

    public changeLessonStatus = (status: any) =>{
      this.setState({lessonStatus: status})
    }

    viewLessonTitle = () => {
        const { userHomeMyCourses } = this.props;
        const { lessonStatus } = this.state;
    
        if (!userHomeMyCourses || userHomeMyCourses.length === 0) {
            return null;
        }
    
        if (userHomeMyCourses[0].activeStatus === 1) {
            return T.t("r_active_courses");
        }
    
        if (userHomeMyCourses[0].activeStatus === 0) {
            return T.t("r_passive_courses");
        }
    
        if (lessonStatus !== 1) {
            return T.t("r_passive_courses");
        }
    
        return T.t("r_active_courses");
    };
    
    
    

    public render() {
        return (
            <><div className="row d-flex justify-content-between align-items-center mobile-lesson-navbar" style={{ margin: 'auto', padding: '5px 0px'}}>
                <div className="page-header-title">
                    <div>
                        <h2 className="alms-h3">{T.t('r_menu_my_courses')}</h2>
                    </div>
                </div>
                <div className="page-header-buttons">
                    <a data-toggle="collapse" href="#my_courses_filter" aria-expanded="true" aria-controls="my_courses_filter"
                        className="alms-btn btn-default btn-icon btn-success" ><span className="material-icons">filter_alt</span>{T.t('r_activity_filter')}</a>
                </div>


            </div>
            <div className="collapse show" id="my_courses_filter">
                    <FilterCourses {...this.props}  changeLessonStatus={this.changeLessonStatus}/>
                </div>
                <div> <span className="font-w500">

                    {this.viewLessonTitle()}
                    </span> </div>
                </>
                
            
        );
    }
}



const mapStateToProps = (state: IAppState, ownProps: ISearchBarProps): ISearchBarProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: ISearchBarProps = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const CourseHeaderInstance = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CourseHeader);


export default CourseHeaderInstance;
